import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'

import Nav from './Nav'

const Menu = ({ showMenu }) => {
  const data = useStaticQuery(graphql`
    query GetMenuLinks {
      allSanityPromotion(sort: { fields: name, order: ASC }) {
        nodes {
          id
          name
          gatsbyPath(filePath: "/promotion/{SanityPromotion.slug__current}")
        }
      }

      allSanityYear(sort: { fields: name, order: ASC }) {
        nodes {
          id
          name
          gatsbyPath(filePath: "/year/{SanityYear.slug__current}")
        }
      }

      allSanityCollection(sort: { fields: name, order: ASC }) {
        nodes {
          id
          name
          gatsbyPath(filePath: "/collection/{SanityCollection.slug__current}")
          promotions {
            abbreviation
          }
        }
      }

      allSanityEvent(sort: { fields: date, order: ASC }) {
        nodes {
          id
          name
          slug {
            current
          }
          promotion {
            abbreviation
          }
        }
      }
    }
  `)

  const events = data?.allSanityEvent?.nodes ?? {}
  const years = data?.allSanityYear?.nodes ?? {}
  const collections = data?.allSanityCollection?.nodes ?? {}
  const promotions = data?.allSanityPromotion?.nodes ?? {}

  const nwawcwCollections = collections.filter((collection) =>
    collection.promotions.some(
      (promotion) =>
        promotion.abbreviation === 'NWA' || promotion.abbreviation === 'WCW',
    ),
  )

  const wwfCollections = collections.filter((collection) =>
    collection.promotions.some((promotion) => promotion.abbreviation === 'WWF'),
  )

  return (
    <Wrapper className="menu" visible={showMenu}>
      <Container>
        <Nav
          promotions={promotions}
          years={years}
          nwawcwCollections={nwawcwCollections}
          wwfCollections={wwfCollections}
          events={events}
        />
      </Container>
    </Wrapper>
  )
}

const Wrapper = styled.nav`
  background: var(--color-background);
  display: ${({ visible }) => (visible ? `block` : `none`)};
  height: calc(100vh - var(--header-height));
  overflow: auto;
  padding: var(--padding-x);
`

const Container = styled.div`
  max-width: var(--max-width);
  margin: 0 auto;
`

export default Menu
